/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

export interface ContentCityFurnishedApartmentsProps {
  cityName: string;
}

export const ContentCityFurnishedApartments = ({
  cityName,
}: ContentCityFurnishedApartmentsProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Furnished Apartments for Rent in ${cityName}, Nederland`}
      </Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`Searching for furnished apartments in ${cityName}? Kamernet will help you
        find furnished apartments for rent in ${cityName}’s most desirable
        neighborhoods. Use our search filters to browse fully furnished rentals
        in ${cityName} within your budget and preferences. Whether you’re looking for
        a furnished studio or ready-to-move apartment, we are here to help you
        every step of the way. Start your search and find furnished rentals in
        the municipality of ${cityName} today!`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Ready to Move-in Flats in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Kamernet helps you find short-term and long-term furnished apartments in
        ${cityName}, with flexible leases starting from just 1 month and extending to
        a year or longer. Our platform features a wide selection of high-quality
        fully furnished properties in ${cityName}, including 1-bedroom, 2-bedroom,
        and 3-bedroom apartments. Each apartment is fully equipped with
        appliances, furniture, Wi-Fi, and utilities already set up, so you can
        move in without hassle. Since 2000, Kamernet has been dedicated to
        providing ${cityName} furnished apartments that are ready for immediate
        occupancy. You’ll find furnished apartments in ${cityName} ideal for student
        housing, corporate stays, or any extended visit to the city.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        Why Kamernet?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Kamernet is the best website to find furnished apartments in ${cityName},
        with hundreds of listings updated regularly. Simply signup on Kamernet
        and get faster access to exclusive rentals you won’t find elsewhere,
        with no middlemen and no agency fees. Discover a wide range of
        move-in-ready places in ${cityName} and register quickly to contact the
        landlord or your future housemate directly. So if you are actively
        searching for furnished apartments in ${cityName}, then visit Kamernet.nl
        today and find fully furnished apartments in ${cityName} without the usual
        delays or hidden fees.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Gemeubileerde Appartementen te Huur in ${cityName}, Nederland`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar een gemeubileerd appartement in ${cityName}? Kamernet helpt je
        bij het vinden van een geschikte woning in de populairste wijken van
        ${cityName}. Gebruik onze zoekfilters om eenvoudig een gemeubileerd
        appartement te huren in ${cityName}, volledig afgestemd op jouw budget en
        voorkeuren. Of je nu kiest voor een studio of een instapklaar
        appartement, wij begeleiden je bij elke stap. Start vandaag je zoektocht
        en vind snel een woning in de gemeente ${cityName} die helemaal klaar is om
        in te trekken.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        {`Instapklare Appartementen in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Via Kamernet huur je moeiteloos een gemeubileerd appartement in ${cityName},
        zowel voor korte als lange periodes. Je kunt al huren vanaf één maand,
        met flexibele looptijden tot een jaar of langer. Ons aanbod bestaat uit
        volledig ingerichte appartementen in ${cityName}, variërend van 1-, 2- tot
        3-kamerwoningen. Elk appartement is ingericht met meubels, apparatuur,
        Wi-Fi en werkende nutsvoorzieningen. Zo kun je direct en zonder zorgen
        verhuizen. Sinds 2000 biedt Kamernet instapklare gemeubileerde
        appartementen aan in ${cityName}, ideaal voor studenten, expats en iedereen
        die langer in de stad blijft.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Waarom Kamernet?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Kamernet is dé plek om een gemeubileerd appartement te huren in ${cityName}.
        Er worden dagelijks nieuwe woningen toegevoegd, verspreid over diverse
        buurten. Registreer je eenvoudig en krijg direct toegang tot exclusieve
        appartementen die je niet op andere websites vindt. Je huurt
        rechtstreeks van de verhuurder, zonder makelaar of extra kosten. Of je
        nu tijdelijk verblijft of voor langere tijd zoekt, je vindt bij Kamernet
        altijd een passende woning in ${cityName}. Ben je op zoek naar een volledig
        gemeubileerd appartement? Bezoek dan vandaag nog Kamernet.nl en begin
        met huren zonder gedoe of verborgen kosten.`}
      </Typography>
    </React.Fragment>
  );
};
